module.exports = __webpack_public_path__ + "img/4221c17.webp";